import React, { useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import MRMSLegend from '../menu/legend-menu-items/mrms-legend.js';

const classes = {
    mrmsFeatureInfoContainer: {
        padding: '10px',
        textAlign: "center"
    }
};


/**
* Component for rendering results from getFreatureInfo wms requests
*
* @prop (obj) data - json response obj from getFreatureInfo request
* @prop (obj) styleInfo - legend info that pertains only to MRMS (derived from top-level state obj: styleInfo)
**/
export default function MRMSFeatureInfo(props) {

    if (Object.keys(props.data).length === 0) {
        return(<CircularProgress sx={{margin: '70px 20px'}} />);
    }

    if (props.data.features && props.data.features.length > 0) {
        return(
            <div style={classes.mrmsFeatureInfoContainer}>
                <div style={{
                    borderBottom: '1px solid rgba(0, 0, 0, .125)',
                    marginLeft: 10, marginRight: 10,
                    }}
                >
                 { (props.styleInfo) ?
                    <MRMSLegend
                        MRMSStyleInfo={props.styleInfo}
                    />
                    : null
                }
                </div>
                <br />
                <Typography align="center">{props.data.features[0].properties.Band1} dBZ</Typography>
                <br />
                <Typography sx={{fontSize: '0.8em'}} align="center">Valid Date/Time:{props.data.timeStamp}</Typography>
                <br />

            </div>
        );
    } else {
        return(null);
    }
}